/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `ADMIN` - Can do everything
 * * `TEAM_MEMBER` - Can post and pay gigs, and can select applicants, but cannot access Billing, Manage Team, Edit or Add Locations
 * * `ONSITE_MANAGER` - Onsite Manager
 */
export type LocationManagerRoleEnum = typeof LocationManagerRoleEnum[keyof typeof LocationManagerRoleEnum];


export const LocationManagerRoleEnum = {
  ADMIN: 'ADMIN',
  TEAM_MEMBER: 'TEAM_MEMBER',
  ONSITE_MANAGER: 'ONSITE_MANAGER',
} as const;
